import { ExitIcon } from "../../../../assets/svg/ExitIcon";
import { useAppDispatch } from "../../../../redux/store";
import { logout } from "../../../../redux/reducers/user/userReducer";
import { useNavigate } from "react-router-dom";
import PlayCanvasService from "../../../../services/PlayCanvasService/PlayCanvasService";

export const LogoutButton = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    navigate("/login");
    dispatch(logout());
    PlayCanvasService.clearRootManager();
    // // @ts-ignore
    //   window.containerRef = null;
    // @ts-ignore
    window.firstLoad = false;
    localStorage.removeItem("authInfo");
  };

  return (
    <button type="button" data-tour="logout-btn" onClick={handleLogout}>
      <ExitIcon />
    </button>
  );
};
